import GampbleAware from "../assets/media/gambleaware.svg"
import GampblingTherapi from "../assets/media/gamblingtherapy.svg"
import LogoWhite from "../assets/images/star123-logo.webp"
import { NavLink } from "react-router-dom";
import FooterCharts from "./FooterCharts";
// import PrivacyPolicy from "./PrivacyPolicy";

const Footer = () => {
    return (
        <footer className="bg-footer-theme overflow-hidden">
            <div
                style={{
                    padding: "1rem",
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem"
                }}
                className="container text-center"
            >
                <div
                    style={{
                        display: "flex",
                        gap: "1rem",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <img
                        alt="Star123 Official logo"
                        loading="lazy"
                        width={140}
                        height={93}
                        decoding="async"
                        style={{ color: "transparent" }}
                        src={LogoWhite}
                    />
                </div>
                <div>
                    <div>
                        <p className="text-white">
                            Players need to be 18+ in order to register. Underage gambling is
                            prohibited.
                        </p>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-around",
                            width: "100%"
                        }}
                    >
                        <div
                            style={{
                                position: "relative",
                                overflow: "hidden",
                                zIndex: 1,
                                display: "inline-flex",
                                width: "45%",
                                height: "auto",
                                justifyContent: "center"
                            }}
                        >
                            <a href="https://www.begambleaware.org">
                                <img
                                    alt="BeGambleAware"
                                    loading="lazy"
                                    width={426}
                                    height={140}
                                    decoding="async"
                                    data-nimg={1}
                                    style={{
                                        color: "transparent",
                                        objectFit: "contain",
                                        width: "100%",
                                        position: "relative",
                                        height: "100%",
                                        maxWidth: 400
                                    }}
                                    src={GampbleAware}
                                />
                            </a>
                        </div>
                        <div
                            style={{
                                position: "relative",
                                overflow: "hidden",
                                zIndex: 1,
                                display: "inline-flex",
                                width: "45%",
                                height: "auto",
                                justifyContent: "center"
                            }}
                        >
                            <a href="https://www.gamblingtherapy.org/">
                                <img
                                    alt="Gambling Therapy"
                                    loading="lazy"
                                    width={949}
                                    height={356}
                                    decoding="async"
                                    data-nimg={1}
                                    style={{
                                        color: "transparent",
                                        objectFit: "contain",
                                        width: "100%",
                                        position: "relative",
                                        height: "100%",
                                        maxWidth: 400
                                    }}
                                    src={GampblingTherapi}
                                />
                            </a>
                        </div>
                    </div>
                    <div>
                        <p className="text-white">
                            Our website is operated by Star123 International, a company
                            established under the law of Malta, with registered address 3 St.
                            Patrick's, II-Belt Valletta, Malta, and having its gaming sublicense
                            issued by Malta e-Gaming Authority and all rights to operate the
                            gaming software worldwide.
                        </p>
                    </div>
                    <div
                        style={{
                            width: "100%",
                            height: "0.5px",
                            backgroundColor: "#efefef",
                            opacity: "0.5"
                        }}
                    />
                    <div className="mb-5">
                        <p className="text-white">
                            Copyright © 2024 - Star123. All Rights Reserved
                        </p>
                        <div className="footer-links" style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "1rem",
                            flexWrap: "wrap",
                            marginTop: "2rem",
                            marginBottom: "2rem"
                        }}>
                            <NavLink
                                to="/privacy-policy"
                                style={{
                                    textDecoration: "none",
                                    color: "white",
                                }}>
                                Privacy Policy
                            </NavLink>
                            <span className="text-white" style={{ opacity: 0.5 }}>|</span>
                            <NavLink
                                to="/how-to-play"
                                style={{
                                    textDecoration: "none",
                                    color: "white",
                                }}>
                                How to play
                            </NavLink>
                            <span className="text-white" style={{ opacity: 0.5 }}>|</span>
                            <NavLink
                                to="/game-rules"
                                style={{
                                    textDecoration: "none",
                                    color: "white",
                                }}>
                                Game Rules
                            </NavLink>
                        </div>
                        <FooterCharts />
                    </div>

                </div>
            </div>

            {/* Charts Section */}
        </footer>

    );
};

export default Footer;
